/* eslint-disable @typescript-eslint/no-explicit-any */
const DisplayDetail = ({
    id,
    idSetter,
    setter,
    clientName,
    clientNameSetter,
}: any) => {

    const handleDisplayDetail = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        if (id !== 0 && idSetter && id) {
            idSetter(id);
        }
        if (setter) {
            setter("view");
        }
        if (clientName && clientNameSetter) {
            clientNameSetter(clientName);
        }
    }

  return (
    <button
      type="button"
      onClick={(e) => handleDisplayDetail(e)}
      className="inline-flex shrink-0 cursor-pointer items-center gap-1.5 rounded-full border border-light-red/30 bg-light-red px-3 py-1.5 font-Nunito text-xs font-semibold whitespace-nowrap text-white shadow-sm shadow-light-red/25 transition-all duration-200 hover:bg-light-red/90 hover:shadow-md hover:shadow-light-red/30 hover:-translate-y-px active:translate-y-0 focus-visible:ring-2 focus-visible:ring-light-red/40 focus-visible:outline-none"
    >
      Détail
      <svg
        aria-hidden="true"
        className="size-3.5"
        fill="none"
        stroke="currentColor"
        strokeWidth={2.4}
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5-5 5M6 12h12" />
      </svg>
    </button>
  )
}

export default DisplayDetail
